// import { createI18n, castToVueI18n } from 'vue-i18n-bridge'
import VueI18n from "vue-i18n";
import Vue from "vue";

import en from "./lang/en.json";
import ru from "./lang/ru.json";
import cz from "./lang/cz.json";
import pl from "./lang/pl.json";
import de from "./lang/de.json";

Vue.use(VueI18n);

const savedLocale = localStorage.getItem("language") || "en";
const defaultLocale = savedLocale;

function customPluralChoice(choice, choicesLength) {
  if (choice === 0) {
    return 2;
  }

  const teen = choice % 100;
  if (teen >= 11 && teen <= 14) {
    return 2;
  }
  const ends = choice % 10;
  if (ends === 1) {
    return 0;
  }
  if (ends >= 2 && ends <= 4) {
    return 1;
  }
  return 2;
}

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "en",
  pluralizationRules: {
    ru: customPluralChoice,
  },
  messages: {
    en: en,
    ru: ru,
    cz: cz,
    pl: pl,
    de: de,
  },
});

export default i18n;
